import React, { useContext } from 'react';
import { PRODUCT_PERMISSIONS, RecordsTable, USER_PERMISSIONS } from 'dyl-components';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { AccountsTableHeader } from './Header';
import { AccountsRow } from './Row';
import Forms from './Forms';
import QuoteBuilderModal from 'shared/modals/QuoteBuilderModal';
import { FormsContext } from './FormsProvider';

export const AccountsTable = ({ isColumnHidden, onFilter, onPageChange, readAccounts, setIsDropDownOpen }) => {
    const [params] = useSearchParams();

    const { accountReducer, accountBeingUnlinked, isDeletingMasterAccount } = useSelector(state => ({
        accountReducer: state.account,
        accountBeingUnlinked: state.master_account.accountBeingUnlinked,
        isDeletingMasterAccount: state.master_account.isDeletingMasterAccount
    }));
    const { accounts = [], isReadingAccounts, accounts_count } = accountReducer;

    const isTableLoading = isReadingAccounts || isDeletingMasterAccount || accountBeingUnlinked !== null;
    const { accountConversion } = useContext(FormsContext);
    return (
        <React.Fragment>
            <Forms readAccounts={readAccounts} />
            <RecordsTable
                tableBodyClassName='AccountsTable'
                isTableLoading={isTableLoading}
                isSearchResultEmpty={accounts_count === 0 && (params.get('search') || params.get('start') || params.get('end') || params.get('account_type') || params.get('owned_by'))}
                isTableEmpty={accounts_count === 0 && !(params.get('search') || params.get('start') || params.get('end') || params.get('account_type') || params.get('owned_by'))}
                TableHeader={<AccountsTableHeader isColumnHidden={isColumnHidden} onFilter={onFilter} />}
                TableRows={accounts?.map(account => (
                    <AccountsRow
                        key={account.id}
                        account={account}
                        isColumnHidden={isColumnHidden}
                    />
                ))}
                recordsCount={accounts_count}
                activePage={params.get('page')}
                onPageChange={onPageChange}
                recordsName='Account'
                onClick={()=>{setIsDropDownOpen(true)}}
                userPermission={USER_PERMISSIONS.ACCOUNT_ADD}
                productPermission={PRODUCT_PERMISSIONS.RECORDS}
            />
            <QuoteBuilderModal
                account_id={accountConversion?.id}
                contact_id={accountConversion?.primary_person_id}
                account_primary_contact_id={accountConversion?.primary_person_id}
            />
        </React.Fragment>
    );
}


